<script>
    import Panel from "./content-panel/Panel.svelte";
    import { Circle } from 'svelte-loading-spinners';
    import { onMount, onDestroy } from 'svelte';
    import { Constans } from '../lib/Constants';
    import { navigateTo } from 'svelte-router-spa';
    import { t, locale, locales } from "../../scripts/i18n";

    onMount(() => {
        window.scrollTo(0, 0);
    });

    export let params = {};
    let divHeight;

    $: params && (params.stage.status !== Constans.CLEANING_COMPLETE) && navigateTo('/demo');
    let username = null;
    $: params && params.stage.account && (username = params.stage.account.username);

    let followsBotsCleaned = 0;
    $: params && params.stage && (followsBotsCleaned = params.stage.cleanupStats.followsBots);
    let followersBotsCleaned = 0;
    $: params && params.stage && (followersBotsCleaned = params.stage.cleanupStats.followersBots);
    let followsCommercialCleaned = 0;
    $: params && params.stage && (followsCommercialCleaned = params.stage.cleanupStats.followsCommercial);
    let followersCommercialCleaned = 0;
    $: params && params.stage && (followersCommercialCleaned = params.stage.cleanupStats.followersCommercial);
    let followsNonreciprocalCleaned = 0;
    $: params && params.stage && (followsNonreciprocalCleaned = params.stage.cleanupStats.followsNonreciprocal);
    let followersNonreciprocalCleaned = 0;
    $: params && params.stage && (followersNonreciprocalCleaned = params.stage.cleanupStats.followersNonreciprocal);
    let followsInactiveCleaned = 0;
    $: params && params.stage && (followsInactiveCleaned = params.stage.cleanupStats.followsInactive);
    let followersInactiveCleaned = 0;
    $: params && params.stage && (followersInactiveCleaned = params.stage.cleanupStats.followersInactive);
    let followsForeignersCleaned = 0;
    $: params && params.stage && (followsForeignersCleaned = params.stage.cleanupStats.followsForeigners);
    let followersForeignersCleaned = 0;
    $: params && params.stage && (followersForeignersCleaned = params.stage.cleanupStats.followersForeigners);
    let followsUnattainableCleaned = 0;
    $: params && params.stage && (followsUnattainableCleaned = params.stage.cleanupStats.followsUnattainable);
    let followersUnattainableCleaned = 0;
    $: params && params.stage && (followersUnattainableCleaned = params.stage.cleanupStats.followersUnattainable);

    let cleanFinishDate = new Date();
    $: params && params.stage && (cleanFinishDate = new Date(params.stage.cleanupStats.finishedAt));

    let isStarting = false;
    function startAnalyze(event) {
        isStarting = true;

        setTimeout(() => {
            isStarting = false;
            params.setStage({
                status: Constans.ANALYZE_STARTED,
                cleanupStats: {
                    cleanProgress: 0,
                    threadsRemoved: 0,
                },
            });
            navigateTo('/demo/analyze-in-progress');
        }, 1000);
    }

</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="title">{$t('Result')}</span>
            <div slot="content">
                <div class="status-panel">
                    <ul class="list-inline">
                        <li class="list-inline-none">{$t('Step 1: Scan')}</li>
                        <li class="list-inline-none">{$t('Step 2: Settings and cleaning')}</li>
                        <li class="active">{$t('Step 3: Result')}</li>
                    </ul>
                </div>

                <div class="results-wrap">
                    <div class="scan-block_content-step1">
                        <div class="row">
                            <div class="col-lg-5 col-md-5">
                                <div class="scan-block_content-step1-img">
                                    <img src="/static/media/broom.6f355c97.svg" alt="/" style="width: 100%;" />
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-7 ">
                                <p class="scan-block_content-step1-h">
                                    {$t('@photographer.london account cleaned successfully')}
                                    {new Intl.DateTimeFormat('en', { year: 'numeric' }).format(cleanFinishDate)}-{new Intl.DateTimeFormat('en', { month: '2-digit' }).format(cleanFinishDate)}-{new Intl.DateTimeFormat('en', { day: '2-digit' }).format(cleanFinishDate)}
                                    {new Intl.DateTimeFormat('en', { hour12: false, hour: '2-digit' }).format(cleanFinishDate)}:{String((cleanFinishDate).getMinutes()).padStart(2, "0")}:{String((cleanFinishDate).getSeconds()).padStart(2, "0")}
                                </p>
                                <p class="scan-block_content-step1-p">
                                    {$t('Congratulations! Your followers list have been cleared of unwanted accounts. Total has been removed:')}
                                </p>

                                <div class="stats-wrap">
                                    <div class="stat-item titles-wrap">
                                        <div class="stat-description">&nbsp;</div>
                                        <div class="stat-followers-value">{$t('From followers')}</div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Bots')}</div>
                                        <div class="stat-followers-value"><span>{followersBotsCleaned}</span></div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Commercial')}</div>
                                        <div class="stat-followers-value"><span>{followersCommercialCleaned}</span></div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Non reciprocal')}</div>
                                        <div class="stat-followers-value"><span>{followersNonreciprocalCleaned}</span></div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Inactive')}</div>
                                        <div class="stat-followers-value"><span>{followersInactiveCleaned}</span></div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Foreigners')}</div>
                                        <div class="stat-followers-value"><span>{followersForeignersCleaned}</span></div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-description">{$t('Unattainable')}</div>
                                        <div class="stat-followers-value"><span>{followersUnattainableCleaned}</span></div>
                                    </div>
                                </div>



                                <div class="scan-block_content-step1-btn controls-wrap" >
                                    {#if false}
                                    <a href="#" type="button" class="purple-btn purple-btn_hover w-210px h-45px" on:click={startAnalyze}>
                                        {$t('Scan')}
                                        {#if isStarting}
                                            <span class="ml-10px">
                                                <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                            </span>
                                        {/if}
                                    </a>
                                    {/if}
                                    <a href="/demo" type="button" class="purple-btn purple-btn_hover w-210px h-45px">
                                        {$t('Go to dashboard')}
                                    </a>
                                    <p class="scan-block_content-total">{$t('Scans left:')} <span> 3</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </Panel>
    </div>
</div>

<style>
    @media (max-device-width: 480px) {
        .titles-wrap {
            display: none;
        }
    }
    .controls-wrap {
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .stat-item .stat-description {
        width: 38%;
        flex-grow: 1;
    }
    .stat-item .stat-follows-value {
        width: 32%;
        text-align: right;
        font-weight: bold;
        font-family: Roboto;
        font-style: normal;
        color: #000;
        font-size: 18px;
    }
    .stat-followers-value {
        width: 30%;
        text-align: right;
        font-weight: bold;
        font-family: Roboto;
        font-style: normal;
        color: #000;
        font-size: 18px;
    }
</style>